import './styles.css';
import React from 'react';

const Policy = () => {
    return (
        <div className="context">
            <div className="contextTitle">이용약관</div>
            <hr className="titleSeparator"/>

            <div className="terms-content">
                <h2>제1조(목적)</h2>
                <p>
                    아주대학교 총학생회(이하 “총학생회”) 홈페이지(이하 “홈페이지”) 서비스이용약관은 총학생회가 제공하는 홈페이지 서비스의 이용과 관련하여 관리자와 사용자 간의 권리, 의무 및 책임
                    사항 등을 규정함을 목적으로 합니다.
                </p>

                <h2>제2조(정의)</h2>
                <ol>
                    <li>
                        이 약관에서 사용하는 용어의 정의는 아래와 같습니다.
                        <ol type="1">
                            <li>“서비스”란, 홈페이지가 제공하는 모든 서비스 및 기능을 말합니다.</li>
                            <li>“관리자”란, 홈페이지의 개발, 유지보수, 수정, 업데이트, 관리 등을 담당하는 총학생회 임원 혹은 기타 관련자를 말합니다.</li>
                            <li>“사용자”란, 이 약관에 따라 홈페이지에 접속하고 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
                            <li>“회원”이란, 홈페이지에 회원등록을 하고 서비스를 이용하는 자를 말합니다.</li>
                            <li>“비회원”이란, 홈페이지에 회원등록을 하지 않고 서비스를 이용하는 자를 말합니다.</li>
                            <li>“회원등록”이란, 홈페이지에 회원가입을 하고 개인정보 수집 및 이용에 동의함으로써 회원으로 인증되어 홈페이지가 제공하는 서비스를 제한 없이 이용할 수 있게
                                되는 과정을 말합니다.
                            </li>
                            <li>“게시물”이란, 관리자 혹은 사용자가 홈페이지에 게재한 모든 종류의 글, 사진, 영상, 첨부파일, 광고, 건의사항 등을 말합니다.</li>
                            <li>“연락처”란, 회원가입이나 본인 인증 등 사용자의 동의하에 수집된 사용자의 휴대전화 번호, 이메일 등을 말합니다.</li>
                            <li>“소속”이란, 회원 혹은 회원등록을 하려는 개인을 아주대학교 내에서 식별할 수 있는 학과, 학년, 기타 학적 등의 정보를 말합니다.</li>
                            <li>“본인 인증”이란, 아이핀, 휴대전화 번호, 이메일 등을 이용한 본인 확인 절차를 말합니다.</li>
                            <li>“학교 인증”이란, 아주대학교 이메일 등을 이용해 회원 혹은 회원등록을 하려는 자가 아주대학교 소속이거나 관련자임을 확인하는 절차를 말합니다.</li>
                        </ol>
                    </li>
                    <br/>
                    <li>제1항에서 정의되지 않은 본 약관 내 용어의 의미는 상식적이고 일반적인 관행에 따릅니다.</li>
                    <li>제1항에서 정의된 용어의 의미는 “개인정보 수집 및 이용” 안내에 동일하게 적용됩니다.</li>
                </ol>
            </div>
        </div>
    );

}

export default Policy;
